export default {
  readMoreButton: 'Lire plus',
  readLessButton: 'Lire moins',
};
